import {
  atLeastOneDigit,
  atLeastOneSymbol,
  atLeastOneUppercase,
  isEnglish,
  min,
} from "./helpers";

export function strongPassword() {
  return this.test("strongPassword", function (value) {
    const { path, createError } = this;

    if (value) {
      if (!min(8, value)) {
        return createError({ path, message: "رمز عبور باید حداقل ۸ کاراکتر باشد" });
      }

      if (!isEnglish(value)) {
        return createError({ path, message: "رمز عبور باید انگلیسی باشد" });
      }

      if (!atLeastOneUppercase(value)) {
        return createError({
          path,
          message: "رمز عبور باید حداقل یک کاراکتر بزرگ داشته باشد",
        });
      }
      if (!atLeastOneDigit(value)) {
        return createError({
          path,
          message: "رمز عبور باید حداقل یک عدد داشته باشد",
        });
      }
      if (!atLeastOneSymbol(value)) {
        return createError({
          path,
          message:
            "رمز عبور باید حداقل یکی از کاراکتر های مخصوص ($,#,@,!,*,&,.,+,%) را داشته باشد",
        });
      }

      return true;
    }
    return true;
  });
}
